/**
 * O chat na lateral direita (pedido do Igor, 2026-11-03): um botão na página do
 * chat leva a conversa para uma coluna à direita, e a pessoa segue usando as
 * outras telas com ela aberta. De lá, volta à tela cheia ou fecha. O botão do
 * chat no cabeçalho sempre abre em tela cheia.
 *
 * Estado de uma aba só (um valor para o app inteiro); "aberta" fica guardada
 * neste aparelho (preferência visual, como a barra lateral recolhida).
 */
import { useEffect, useState } from "react";

const CHAVE = "pharuerp:chat-lateral";

function lerAberta() {
  try {
    return window.localStorage.getItem(CHAVE) === "1";
  } catch {
    return false;
  }
}

let estado = { aberta: lerAberta(), conversaId: null };
const ouvintes = new Set();

function mudar(novo) {
  estado = { ...estado, ...novo };
  try {
    window.localStorage.setItem(CHAVE, estado.aberta ? "1" : "0");
  } catch {
    /* sem storage: vale até fechar a página */
  }
  ouvintes.forEach((f) => f(estado));
}

/** Leva o chat para a lateral, na conversa que estava aberta (ou na lista). */
export function abrirChatNaLateral(conversaId = null) {
  mudar({ aberta: true, conversaId });
}

export function fecharChatDaLateral() {
  mudar({ aberta: false });
}

/** A lateral guarda a conversa em que a pessoa está (para voltar à tela cheia nela). */
export function lembrarConversaDaLateral(conversaId) {
  if (estado.conversaId !== conversaId) estado = { ...estado, conversaId };
}

export function chatDaLateral() {
  return estado;
}

export function useChatDaLateral() {
  const [atual, setAtual] = useState(estado);
  useEffect(() => {
    ouvintes.add(setAtual);
    setAtual(estado);
    return () => ouvintes.delete(setAtual);
  }, []);
  return atual;
}

/** O endereço da tela cheia: a conversa da lateral, se havia uma. */
export function enderecoDaTelaCheia(conversaId = estado.conversaId) {
  return conversaId ? `/chat/${conversaId}` : "/chat";
}
